module.exports = __webpack_public_path__ + "img/arrow-point-to-right.a0e061b5.svg";